<template>
    <div>
        <ValidationObserver ref="phoneNumberValidator" v-slot="{ invalid }">
            <form @submit.prevent class="c-plan-form__phone-number-form">
                <template v-if="isPortabiliteExist">
                    <div
                        v-for="(option, index) in planDataFromMagento.plan.custom_options.portabilite.options"
                        :key="option.option_type_id"
                        class="custom-control custom-radio gtm-configurateur-phone-number u-marg-b-sm u-flex u-flex-align-center">
                        <input
                            class="custom-control-input"
                            type="radio"
                            :name="`options[${option.option_id}]`"
                            :id="'option-portability-' + index"
                            :checked="checkedStatus(option)"
                            :value="option.option_type_id"
                            @change="onChange(option)">

                        <label class="custom-control-label u-middle" :for="'option-portability-' + index">
                            <span>{{ option.name }}</span>
                        </label>

                    </div>
                </template>

                <!--
                  If this is a homebox we display this input only for information,
                  we don't need to use his value because the backend doesn't need it.
                -->
                <template v-if="isHomebox">
                    <div
                        class="custom-control custom-radio gtm-configurateur-phone-number u-marg-b-sm u-flex u-flex-align-center">
                        <input
                            class="custom-control-input"
                            type="radio"
                            name="get-new-phone-number"
                            id="option-modem-sym-type"
                            :checked="true">

                        <label class="custom-control-label u-middle" for="option-modem-sym-type">
                            <span>{{ planDataFromMagento.plan.custom_options.sim_type.options[0].name }}</span>
                        </label>

                    </div>
                </template>

                <keep-alive>
                    <div>
                    <div class="col-12 alert alert-warning" role="alert"  v-if="phoneNumber.phoneNumberChoice.sku === 'PortabiliteNumero'">
                        <span class="alert-icon"><span class="sr-only">Success</span></span>
                        <div>
                            <h4 class="alert-heading"> {{ $t('Keep your actual number msg') }}</h4>
                        </div>
                    </div>
                    <div class="c-plan-form__keep-phone-number col-11 offset-1 u-marg-b-sm"
                         v-if="phoneNumber.phoneNumberChoice.sku === 'PortabiliteNumero'">
                        <div class="row">
                            <div v-if="isPortabiliteExist" class="col-12">
                                <label for="phoneNumberInput" class="is-required">{{
                                        localData.phoneNumberInputLabel
                                    }}</label>
                            </div>
                            <div v-if="isPortabiliteExist" class="u-pad-r-0 form-group col-3 col-sm-4 col-md-3">

                                <input
                                    :disabled="true"
                                    type="text"
                                    :title="localData.phoneNumberInputLabel"
                                    class="form-control is-required"
                                    id="internationalPhoneNumber"
                                    readonly
                                    placeholder="+352">
                            </div>

                            <div class="form-group col-9 col-sm-8 col-md-9">
                                <ValidationProvider name="phone" rules="required|phone" v-slot="{ errors }">
                                    <input
                                        type="tel"
                                        :maxlength="phoneNumberMaxLength"
                                        @keyup="formatWithSpace"
                                        v-model="phoneNumber.phoneNumberInput"
                                        class="form-control is-required"
                                        id="phoneNumberInput"
                                        :title="localData.phoneNumberInputLabel"
                                        placeholder="669516219">

                                    <span :class="[errors.length > 0 ? 'invalid-feedback u-flex' : '']">
                  {{ errors[0] }}
                </span>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div v-if="isPortabiliteOperatorExist" class="form-group">

                            <label for="providerSelect">
                                {{ localData.providerSelect.title }}
                            </label>

                            <ValidationProvider name="provider" rules="required" v-slot="{ errors }">
                                <select
                                    v-model="phoneNumber.keepPhoneNumber.provider"
                                    class="custom-select is-required"
                                    :title="localData.providerSelect.title"
                                    id="providerSelect"
                                    @change="isOrangeLuOperator($event)"
                                >

                                    <option
                                        v-for="(option, index) in localData.providerSelect.options"
                                        :key="option.value + index"
                                        :value="option.value"
                                        :disabled="option.disabled">
                                        {{ option.label }}
                                    </option>
                                </select>
                                <span :class="[errors.length > 0 ? 'invalid-feedback u-flex' : '']">
                {{ errors[0] }}
              </span>
                            </ValidationProvider>
                        </div>

                        <div v-if="isPortabiliteDateExist" v-show="showDateAndSimField" class="form-group">
                            <label for="portabilityDate" class="is-required">
                                {{ localData.portabilityDate }}
                            </label>

                            <ValidationProvider name="portabilityDate" rules="required" v-slot="{ errors }">

                                <flat-pickr
                                    ref="portabilityDateForPlan"
                                    v-model="phoneNumber.keepPhoneNumber.portabilityDate"
                                    :config="config"
                                    :class="['form-control is-required', selectedPortabilityDate ? 'c-plan-form__phone-number-form-portability-date-selected' : '']"
                                    :placeholder="defaultDate"
                                    @on-change="selectedPortabilityDate = true"
                                    name="portabilityDate">
                                </flat-pickr>

                                <span :class="[errors.length > 0 ? 'invalid-feedback u-flex' : '']">
                {{ errors[0] }}
              </span>
                            </ValidationProvider>

                        </div>

                        <div v-if="isPortabiliteSimExist" v-show="showDateAndSimField" class="form-group">
                            <label for="iccid">
                                {{ localData.iccid }}
                            </label>

                            <ValidationProvider name="iccid" rules="required|iccid" v-slot="{ errors }">

                                <input
                                    type="text"
                                    pattern="[0-9]*"
                                    class="form-control is-required"
                                    id="iccid"
                                    :title="localData.iccid"
                                    @keyup="checkLength"
                                    v-model="phoneNumber.keepPhoneNumber.iccid"
                                    placeholder="89352994545568856455">

                                <span :class="[errors.length > 0 ? 'invalid-feedback u-flex' : '']">
                  {{ errors[0] }}
                </span>
                            </ValidationProvider>

                        </div>

                        <a v-show="showDateAndSimField"
                            v-if="isPortabiliteSimExist"
                            data-toggle="modal"
                            data-target="#iccid_popin-modal"
                            class="c-plan-form__link u-grey-text u-bold"> {{ localData.findNumber }} </a>
                    </div>
                        <div class="col-12 alert alert-danger" role="alert"  v-if="phoneNumber.phoneNumberChoice.sku === 'PortabiliteNumero'" v-show="showNumberPorting">
                            <span class="alert-icon"><span class="sr-only">Success</span></span>
                            <div>
                                <h4 class="alert-heading" v-html="errorMsg"></h4>
                            </div>
                        </div>
                    </div>
                </keep-alive>

                <button
                    @click="nextStep"
                    type="button"
                    id="next-step"
                    :class="['btn btn-lg btn-primary', invalid ? 'disabled u-pointer-none' : '']">
                    {{ localData.nextStep }}
                </button>

            </form>
        </ValidationObserver>
    </div>

</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

import { AsYouType, parsePhoneNumber } from 'libphonenumber-js/min';

import flatPickr from 'vue-flatpickr-component';
import flatPickrLocale from 'flatpickr/dist/l10n/fr.js';
import 'flatpickr/dist/flatpickr.css';

import debounce from 'lodash.debounce';

import Helpers from '~plugins/Helpers';

import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import en from 'dayjs/locale/en';
import fr from 'dayjs/locale/fr';

export default {
    components: {
        flatPickr,
        ValidationProvider,
        ValidationObserver
    },
    props: {
        planDataFromMagento: {
            type: Object,
            default: () => null
        },
        traduction: {
            type: Function
        },
        dataFromCart: {
            type: Object,
            default: () => null
        }
    },
    computed: {
        $t() {
            return this.traduction;
        },
        //$t: 'GET_TRAD',
        config: function () {
            dayjs.extend(weekday);

            if (this.planDataFromMagento.locale === 'en') {
                dayjs.locale({
                    ...en,
                    weekStart: 1
                });
            } else {
                dayjs.locale(fr);
            }

            const laps = 5; // number of days before the picking up phone
            let additionalDays = 0;

            // in 8 days needs to be working day, so we add one or two date to current date if
            // current day + 8 has saturday or sunday in it
            for (let i = 0; i < laps; i++) {
                if (dayjs()
                    .add(i, 'day')
                    .get('day') === 0 || dayjs()
                    .add(i, 'day')
                    .get('day') === 6) {
                    additionalDays += 1;
                }
            }

            let inHeightDays = dayjs()
                .add(laps + additionalDays, 'day').$d;
            let inFourtyDays = dayjs()
                .weekday(40).$d;

            let frLocale = flatPickrLocale.fr;
            let enLocale = flatPickrLocale.en;

            enLocale.firstDayOfWeek = 1;

            return {
                minDate: inHeightDays,
                dateFormat: Helpers.currentFormat(this.planDataFromMagento.locale),
                disable: [
                    function (date) {
                        return (date.getDay() === 0 || date.getDay() === 6);
                    }
                ],
                altFormat: Helpers.currentFormat(this.planDataFromMagento.locale),
                altInput: true,
                maxDate: inFourtyDays,
                locale: this.planDataFromMagento.locale === 'en' ? enLocale : frLocale,
                defaultDate: this.planDataFromMagento.locale === 'en' ? Helpers.currentDay('en') : Helpers.currentDay('fr')
            };
        },
        defaultDate: function () {
            return this.planDataFromMagento.locale === 'en' ? Helpers.currentDay('en') : Helpers.currentDay('fr');
        }
    },
    watch: {
        'phoneNumber.keepPhoneNumber.phoneNumber': {
            handler: debounce(function () {
                Helpers.pushDataLayer({
                    'event': 'Configurator field',
                    'click_name': this.localData.phoneNumberInputLabel,
                    'click_category': 'Obligatoire'
                });
            }, 600)
        },
        'phoneNumber.keepPhoneNumber.provider': {
            handler: debounce(function () {
                Helpers.pushDataLayer({
                    'event': 'Configurator field',
                    'click_name': this.localData.providerSelect.title,
                    'click_category': 'Obligatoire'
                });
            }, 600)
        },
        'phoneNumber.keepPhoneNumber.portabilityDate': {
            handler: debounce(function () {
                Helpers.pushDataLayer({
                    'event': 'Configurator field',
                    'click_name': this.localData.portabilityDate,
                    'click_category': 'Obligatoire'
                });
            }, 600)
        },
        'phoneNumber.keepPhoneNumber.iccid': {
            handler: debounce(function () {
                Helpers.pushDataLayer({
                    'event': 'Configurator field',
                    'click_name': this.localData.iccid,
                    'click_category': 'Obligatoire'
                });
            }, 600)
        }
    },
    data() {
        return {
            formValidated: true,
            selectedPortabilityDate: false,
            localData: {
                getNewPhoneNumber: 'Obtenir un nouveau numéro',
                keepPhoneNumber: 'Conserver mon numéro actuel',
                phoneNumberInputLabel: 'Votre numéro',
                providerSelect: {
                    title: 'Mon opérateur actuel',
                    options: [
                        {
                            disabled: true,
                            label: 'Sélectionnez votre opérateur',
                            value: ''
                        },
                        {
                            disabled: false,
                            label: 'Tango',
                            value: 'Tango'
                        },
                        {
                            disabled: false,
                            label: 'Join Experience',
                            value: 'Join Experience'
                        },
                        {
                            disabled: false,
                            label: 'Eltrona',
                            value: 'Eltrona'
                        },
                        {
                            disabled: false,
                            label: 'Luxembourg Online',
                            value: 'Luxembourg Online'
                        }
                    ]
                },
                portabilityDate: 'Date de portabilité souhaitée',
                iccid: 'Mon numéro de SIM actuel (ICCID)',
                findNumber: 'Où trouver ce numéro ? >',
                nextStep: 'Étape suivante'
            },
            phoneNumber: {
                internationalPhoneNumber: '+352',
                phoneNumberInput: '',
                phoneNumberChoice: {},
                keepPhoneNumber: {
                    keepPhoneNumber: true,
                    phoneNumber: '',
                    provider: '',
                    portabilityDate: '',
                    iccid: ''
                }
            },
            phoneNumberMaxLength: 9,
            isPortabiliteExist: false,
            isPortabiliteOperatorExist: false,
            isPortabiliteSimExist: false,
            isPortabiliteDateExist: false,
            isHomebox: false,
            showDateAndSimField:true,
            showNumberPorting :false,
            errorMsg: ''
        };
    },
    beforeMount() {

        if (this.planDataFromMagento) {
            const custom_options = this.planDataFromMagento.plan.custom_options;

            this.isPortabiliteExist = custom_options && 'portabilite' in custom_options;
            this.isPortabiliteOperatorExist = custom_options && 'portability_operator' in custom_options;
            this.isPortabiliteSimExist = custom_options && 'portability_sim' in custom_options;
            this.isPortabiliteDateExist = custom_options && 'portability_date' in custom_options;

            if (this.planDataFromMagento.plan.categorization === 'homebox') {
                this.isHomebox = true;
            }

            /**
             * Check for every key,
             * In case we arrive on a page ( Homebox for example ) where the form is not needed
             */

            this.phoneNumber.phoneNumberChoice = this.isPortabiliteExist ? this.planDataFromMagento.plan.custom_options.portabilite.options[0] : {};
            this.localData.phoneNumberInputLabel = this.isPortabiliteExist ? this.planDataFromMagento.plan.custom_options.portabilite.label : '';
            this.localData.nextStep = this.$t('Next step');
            this.localData.findNumber = this.$t('Where do I find this number? >');
            this.localData.iccid = this.$t('Current SIM number (ICCID)');
            this.localData.portabilityDate = this.$t('Transfer date');

            let operator = [];
            let getLuOperator = [];
            let getOrangeLuOperator = [];

            if (this.isPortabiliteOperatorExist) {
                this.localData.providerSelect = {
                    title: this.planDataFromMagento.plan.custom_options.portability_operator.label,
                    options: [
                        {
                            disabled: true,
                            label: this.$t('Current provider'),
                            isDefault: '',
                            value: ''
                        }
                    ]
                };

                operator = this.planDataFromMagento.plan.custom_options.portability_operator.options.map(item => {
                    return {
                        disabled: false,
                        label: item.name,
                        value: item.option_type_id
                    };
                });

                getLuOperator = operator.splice(2,1);
                operator = operator.concat(getLuOperator);

                getOrangeLuOperator = operator.splice(operator.findIndex(op => op.label === 'Orange Luxembourg'), 1);
                operator = operator.concat(getOrangeLuOperator);

                this.errorMsg = this.$t('Number porting is only possible for customers of another provider');

                this.localData.providerSelect.options = [...this.localData.providerSelect.options, ...operator];
            }

            this.localData.iccid = this.isPortabiliteSimExist ? this.planDataFromMagento.plan.custom_options.portability_sim.label : '';
            this.localData.portabilityDate = this.isPortabiliteDateExist ? this.planDataFromMagento.plan.custom_options.portability_date.label : '';

            // If dataFromCart exists, this means the user comes from his cart and
            // want to modify his data.
            if (this.dataFromCart) {
                if (this.dataFromCart.keepPhoneNumber) {
                    this.phoneNumber.keepPhoneNumber = this.dataFromCart;
                    this.phoneNumber.phoneNumberInput = this.dataFromCart.phoneNumber;
                    this.phoneNumber.phoneNumberChoice = custom_options.portabilite.options.filter(option => option.sku === 'PortabiliteNumero')[0];

                    if (this.phoneNumber.keepPhoneNumber.portabilityDate.length > 0) {
                        this.phoneNumber.keepPhoneNumber.portabilityDate = this.planDataFromMagento.locale === 'en' ? this.phoneNumber.keepPhoneNumber.portabilityDate : dayjs(this.phoneNumber.keepPhoneNumber.portabilityDate)
                            .format('DD/MM/YYYY');
                    }
                }
            }
        }

    },
    mounted() {
        this.extendValidation();
        Helpers.pushDataLayer({
            'event': 'configurator_field',
            'step': 'phone_number'
        });
    },
    methods: {
        isOrangeLuOperator(event){

         let value =  event.target.value
         let option = this.localData.providerSelect.options.find(op => op.value === value)
         let buttonElement = document.getElementById('next-step');

                if (option.label === 'Orange Luxembourg'){
                    this.showDateAndSimField = false;
                    this.showNumberPorting = true;
                    buttonElement.classList.add('disabled','u-pointer-none');
                } else {
                    this.showDateAndSimField = true;
                    this.showNumberPorting = false;
                    buttonElement.classList.remove('disabled','u-pointer-none');
                }

        },
        checkedStatus(option) {
            return this.phoneNumber.phoneNumberChoice.option_type_id === option.option_type_id;
        },
        onChange(currentOption) {
            this.phoneNumber.phoneNumberChoice = currentOption;
            Helpers.pushDataLayer({
                'event': 'configurator_field',
                'step': 'phone_number_keep_current_number'
            });
            // We add a class to calendar container only after the real dom is updated and when `Portabilite options` exist
            this.$nextTick()
                .then(() => {
                    if (this.$refs.portabilityDateForPlan) {
                        this.$refs.portabilityDateForPlan.fp.calendarContainer.classList.add('portabilityDateForPlan');
                    }
                });
        },
        formatWithSpace() {
            const asYouType = new AsYouType('LU');

            if (this.phoneNumber.phoneNumberInput.length > 4) {
                this.phoneNumber.phoneNumberInput = asYouType.input(this.phoneNumber.phoneNumberInput);
            }

            // Update maxLength to include the whitespaces
            this.phoneNumberMaxLength = 11;
            this.phoneNumber.keepPhoneNumber.phoneNumber = '+352 ' + this.phoneNumber.phoneNumberInput;
        },
        checkLength() {
            if (this.phoneNumber.keepPhoneNumber.iccid.length > 20) {
                this.phoneNumber.keepPhoneNumber.iccid = this.phoneNumber.keepPhoneNumber.iccid.slice(0, 20);
            }
        },
        extendValidation() {
            extend('required', {
                ...required,
                message: this.$t('This field is required')
            });

            extend('phone', (value) => {

                let phoneNumber = false;

                try {
                    phoneNumber = parsePhoneNumber('+352' + value);
                } catch {
                    return this.$t('Invalid phone number');
                }

                if (phoneNumber) {

                    const isStartingBySix = phoneNumber.nationalNumber[0] === '6' ? true : false;

                    if (
                        phoneNumber.isValid() &&
                        phoneNumber.country === 'LU' &&
                        isStartingBySix
                    ) {
                        return true;
                    } else {
                        return this.$t('Invalid phone number');
                    }
                } else {
                    return this.$t('Invalid phone number');
                }
            });

            extend('iccid', (value) => {

                const regex = /^89352\d{14,15}$/g;
                const checkRegex = value.match(regex);

                if (checkRegex && checkRegex[0]) {
                    const isCorrectICCID = this.luhnChecksum(value) === 0 ? true : false;

                    if (isCorrectICCID) {
                        return true;
                    } else {
                        return this.$t('Please provide a valid ICCID number. Example : 89352 followed by 14 or 15 more digits.');
                    }
                } else {
                    return this.$t('Please provide a valid ICCID number. Example : 89352 followed by 14 or 15 more digits.');
                }
            });
        },
        luhnChecksum(code) {

            if (code != '') {

                let len = code.length;
                let parity = len % 2;
                let sum = 0;

                for (let i = len - 1; i >= 0; i--) {

                    let d = parseInt(code.charAt(i));

                    if (i % 2 == parity) {
                        d *= 2;
                    }
                    if (d > 9) {
                        d -= 9;
                    }

                    sum += d;
                }

                return sum % 10;
            } else {
                return false;
            }
        },
        async nextStep() {
            const isValid = await this.$refs.phoneNumberValidator.validate();
            if (isValid) {

                Helpers.pushDataLayer({
                    'event': 'Configurator field',
                    'click_name': 'Steps 1',
                    'click_category': 'Obligatoire'
                });

                if (this.phoneNumber.phoneNumberChoice.sku === 'PortabiliteNumero') {
                    this.$emit('phone-number-next-step', { ...this.phoneNumber.keepPhoneNumber, ...this.phoneNumber.phoneNumberChoice });
                } else {
                    this.$emit('phone-number-next-step', this.phoneNumber.phoneNumberChoice);
                }
            }
        }
    }
};
</script>
